if (!customElements.get('stark-countdown')) {
  customElements.define('stark-countdown', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);
      const date = this.dataset.date || '';
      const time = this.dataset.time || '';
      const offset = this.dataset.offset || '';
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time) || !/^[+-](0\d|1[0-4]):[0-5]\d$/.test(offset)) return;
      const calendar = new Date(date + 'T00:00:00Z');
      if (!Number.isFinite(calendar.getTime()) || calendar.toISOString().slice(0, 10) !== date) return;
      this.deadline = Date.parse(date + 'T' + time + ':00' + offset);
      if (!Number.isFinite(this.deadline)) return;
      this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-' + unit + ']'));
      this.clock = this.querySelector('[role="timer"]');
      this.copy = this.querySelector('.stark-countdown__copy');
      this.expired = this.querySelector('[data-expired]');
      if (this.units.some(unit => !unit) || !this.clock || !this.copy || !this.expired) return;
      if (this.update()) this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
    }
    update() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (remaining === 0) {
        clearInterval(this.interval);
        this.clock.hidden = true;
        this.copy.hidden = true;
        this.expired.hidden = false;
        this.hidden = this.dataset.hideExpired !== 'false';
        return false;
      }
      const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      values.forEach((value, index) => {
        const text = String(value).padStart(2, '0');
        if (this.units[index].textContent !== text) this.units[index].textContent = text;
      });
      this.clock.hidden = false;
      this.copy.hidden = false;
      this.expired.hidden = true;
      this.hidden = false;
      return true;
    }
  });
}
